import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "flex flex-wrap items-center justify-between gap-3" }
const _hoisted_3 = { class: "flex w-full flex-col gap-3" }
const _hoisted_4 = { class: "flex gap-3" }
const _hoisted_5 = { class: "relative flex flex-1" }
const _hoisted_6 = { class: "contents" }
const _hoisted_7 = {
  key: 0,
  class: "w-full"
}
const _hoisted_8 = { class: "space-y-4 p-5" }
const _hoisted_9 = { class: "rounded-md border border-slate-200 bg-slate-50 p-4" }
const _hoisted_10 = { class: "grid gap-4 md:grid-cols-[minmax(0,1fr)_180px_160px]" }
const _hoisted_11 = { class: "min-w-0" }
const _hoisted_12 = { class: "break-words text-base font-semibold leading-6 text-slate-900" }
const _hoisted_13 = { class: "min-w-0" }
const _hoisted_14 = { class: "truncate text-sm text-slate-700" }
const _hoisted_15 = { class: "text-sm text-slate-700" }
const _hoisted_16 = { class: "rounded-md border border-slate-200 bg-white p-4" }
const _hoisted_17 = { class: "whitespace-pre-wrap break-words text-sm leading-6 text-slate-800" }
const _hoisted_18 = { class: "rounded-md border border-slate-200 bg-white" }
const _hoisted_19 = {
  key: 0,
  class: "divide-y divide-slate-100"
}
const _hoisted_20 = ["href"]
const _hoisted_21 = { class: "min-w-0 flex-1 truncate font-semibold" }
const _hoisted_22 = {
  key: 1,
  class: "px-4 py-6 text-center text-sm font-medium text-slate-500"
}
const _hoisted_23 = {
  key: 1,
  class: "w-full"
}
const _hoisted_24 = { class: "space-y-4 p-5" }
const _hoisted_25 = { class: "rounded-md border border-slate-200 bg-slate-50 p-4" }
const _hoisted_26 = { class: "grid gap-4 md:grid-cols-[minmax(0,1fr)_180px_160px]" }
const _hoisted_27 = { class: "min-w-0" }
const _hoisted_28 = { class: "break-words text-base font-semibold leading-6 text-slate-900" }
const _hoisted_29 = { class: "min-w-0" }
const _hoisted_30 = { class: "truncate text-sm text-slate-700" }
const _hoisted_31 = { class: "text-sm text-slate-700" }
const _hoisted_32 = {
  key: 0,
  class: "inline-flex min-w-[108px] items-center justify-center gap-2 rounded-md border border-emerald-200 bg-emerald-50 px-3 py-2 text-sm font-semibold text-emerald-700"
}
const _hoisted_33 = {
  key: 1,
  class: "inline-flex min-w-[108px] items-center justify-center gap-2 rounded-md border border-rose-200 bg-rose-50 px-3 py-2 text-sm font-semibold text-rose-700"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Panel, { header: "Danh sách văn bản" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_DataTable, {
            value: $setup.listDocumentStatus,
            paginator: true,
            stripedRows: "",
            rows: 10,
            rowsPerPageOptions: [10, 25, 50],
            rowHover: true,
            paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
            filters: $setup.filters,
            "onUpdate:filters": _cache[2] || (_cache[2] = ($event: any) => (($setup.filters) = $event)),
            globalFilterFields: ['receiver', 'content'],
            currentPageReportTemplate: "Có tổng số {totalRecords} dữ liêu",
            resizableColumns: "",
            tableclass: "h-[60px]"
          }, {
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_Button, {
                      type: "button",
                      icon: "pi pi-filter-slash",
                      label: "Xoá lọc",
                      outlined: "",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.clearFilter()))
                    }),
                    _createElementVNode("span", _hoisted_5, [
                      _cache[6] || (_cache[6] = _createElementVNode("i", { class: "pi pi-search pointer-events-none absolute left-3 top-1/2 z-10 -translate-y-1/2 text-sm text-slate-400" }, null, -1)),
                      _createVNode(_component_InputText, {
                        class: "!w-[500px] !pl-10 !pr-3",
                        modelValue: $setup.filters['global'].value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.filters['global'].value) = $event)),
                        placeholder: "Tìm theo tên hoặc số điện thoại"
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ])
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_Column, {
                field: "title",
                header: "Tiêu đề văn bản",
                sortable: "",
                class: "h-[60px]"
              }),
              _createVNode(_component_Column, {
                field: "sender",
                header: "Người gởi",
                class: "h-[60px]",
                sortable: ""
              }),
              _createVNode(_component_Column, {
                field: "time",
                header: "Thời gian",
                class: "h-[60px]",
                sortable: ""
              }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString($setup.formatDateTime(slotProps.data.time)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                field: "ratio",
                header: "Tỷ lệ xử lý (Đã xử lý/Tổng số)",
                class: "h-[60px]",
                sortable: ""
              }),
              _createVNode(_component_Column, {
                field: "id",
                header: "Chi tiết văn bản",
                class: "h-[60px]",
                sortable: ""
              }, {
                body: _withCtx((slotProps) => [
                  _createVNode(_component_Button, {
                    outlined: "",
                    label: "Xem",
                    icon: "pi pi-file",
                    onClick: ($event: any) => ($setup.loadDocumentContentDetail(slotProps.data.id))
                  }, null, 8, ["onClick"])
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                field: "id",
                header: "Chi tiết xử lý",
                class: "h-[60px]",
                sortable: ""
              }, {
                body: _withCtx((slotProps) => [
                  _createVNode(_component_Button, {
                    outlined: "",
                    label: "Xem",
                    icon: "pi pi-eye",
                    disabled: $setup.isEmptyRatio(slotProps.data.ratio),
                    onClick: ($event: any) => ($setup.loadDocumentDetail(slotProps.data.id))
                  }, null, 8, ["disabled", "onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value", "filters"])
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_6, [
      ($setup.showDocumentDetail)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_Dialog, {
              header: "Chi tiết văn bản",
              visible: $setup.showDocumentDetail,
              "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => (($setup.showDocumentDetail) = $event)),
              modal: "",
              style: { width: 'min(820px, calc(100vw - 32px))' },
              contentClass: "!p-0"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "mb-1 text-xs font-semibold uppercase text-slate-500" }, " Tiêu đề văn bản ", -1)),
                        _createElementVNode("div", _hoisted_12, _toDisplayString($setup.documentDetail.title || "--"), 1)
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "mb-1 text-xs font-semibold uppercase text-slate-500" }, " Người gửi ", -1)),
                        _createElementVNode("div", _hoisted_14, _toDisplayString($setup.documentDetail.sender || "--"), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "mb-1 text-xs font-semibold uppercase text-slate-500" }, " Thời gian ", -1)),
                        _createElementVNode("div", _hoisted_15, _toDisplayString($setup.formatDateTime($setup.documentDetail.time) || "--"), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _cache[10] || (_cache[10] = _createElementVNode("div", { class: "mb-2 text-xs font-semibold uppercase text-slate-500" }, " Nội dung ", -1)),
                    _createElementVNode("div", _hoisted_17, _toDisplayString($setup.documentDetail.content || "--"), 1)
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _cache[13] || (_cache[13] = _createElementVNode("div", { class: "border-b border-slate-200 bg-slate-50 px-4 py-3 text-sm font-bold text-slate-900" }, " Tập tin đính kèm ", -1)),
                    ($setup.documentDetail.listAttachments?.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.documentDetail.listAttachments, (attachment) => {
                            return (_openBlock(), _createElementBlock("a", {
                              key: attachment.id,
                              href: $setup.attachmentUrl(attachment.link),
                              target: "_blank",
                              rel: "noopener noreferrer",
                              class: "flex items-center gap-3 px-4 py-3 !text-slate-800 !no-underline transition hover:bg-teal-50"
                            }, [
                              _cache[11] || (_cache[11] = _createElementVNode("span", { class: "inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-teal-50 text-teal-700" }, [
                                _createElementVNode("i", { class: "pi pi-paperclip" })
                              ], -1)),
                              _createElementVNode("span", _hoisted_21, _toDisplayString(attachment.fileName), 1),
                              _cache[12] || (_cache[12] = _createElementVNode("i", { class: "pi pi-external-link text-xs text-slate-400" }, null, -1))
                            ], 8, _hoisted_20))
                          }), 128))
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_22, " Không có tập tin đính kèm "))
                  ])
                ])
              ]),
              _: 1
            }, 8, ["visible"])
          ]))
        : _createCommentVNode("", true),
      ($setup.show)
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
            _createVNode(_component_Dialog, {
              header: "Chi tiết trạng thái xử lý văn bản",
              visible: $setup.show,
              "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => (($setup.show) = $event)),
              modal: "",
              style: { width: 'min(920px, calc(100vw - 32px))' },
              contentClass: "!p-0"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _cache[14] || (_cache[14] = _createElementVNode("div", { class: "mb-1 text-xs font-semibold uppercase text-slate-500" }, " Tiêu đề văn bản ", -1)),
                        _createElementVNode("div", _hoisted_28, _toDisplayString($setup.documenStatus.title || "--"), 1)
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        _cache[15] || (_cache[15] = _createElementVNode("div", { class: "mb-1 text-xs font-semibold uppercase text-slate-500" }, " Người gửi ", -1)),
                        _createElementVNode("div", _hoisted_30, _toDisplayString($setup.documenStatus.sender || "--"), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _cache[16] || (_cache[16] = _createElementVNode("div", { class: "mb-1 text-xs font-semibold uppercase text-slate-500" }, " Thời gian ", -1)),
                        _createElementVNode("div", _hoisted_31, _toDisplayString($setup.formatDateTime($setup.documenStatus.time) || "--"), 1)
                      ])
                    ])
                  ]),
                  _createVNode(_component_DataTable, {
                    value: $setup.documenStatus.listReceivers || [],
                    paginator: true,
                    stripedRows: "",
                    rows: 10,
                    rowsPerPageOptions: [10, 25, 50],
                    rowHover: true,
                    paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
                    filters: $setup.filters,
                    "onUpdate:filters": _cache[4] || (_cache[4] = ($event: any) => (($setup.filters) = $event)),
                    globalFilterFields: ['receiver', 'content'],
                    currentPageReportTemplate: "Có tổng số {totalRecords} dữ liệu",
                    resizableColumns: "",
                    tableclass: "h-[60px]",
                    class: "overflow-hidden rounded-md border border-slate-200"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Column, {
                        field: "receiver",
                        header: "Người nhận",
                        sortable: "",
                        class: "h-[60px]"
                      }),
                      _createVNode(_component_Column, {
                        field: "content",
                        header: "Nội dung trả lời",
                        class: "h-[60px]",
                        sortable: ""
                      }),
                      _createVNode(_component_Column, {
                        field: "status",
                        header: "Trạng thái",
                        class: "h-[60px]",
                        sortable: ""
                      }, {
                        body: _withCtx((slotProps) => [
                          (slotProps.data.status)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_32, [...(_cache[17] || (_cache[17] = [
                                _createElementVNode("i", { class: "pi pi-check text-xs" }, null, -1),
                                _createTextVNode(" Đã xử lý ", -1)
                              ]))]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_33, [...(_cache[18] || (_cache[18] = [
                                _createElementVNode("i", { class: "pi pi-hourglass text-xs" }, null, -1),
                                _createTextVNode(" Chưa xử lý ", -1)
                              ]))]))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "createTime",
                        header: "Thời gian nhận",
                        class: "h-[60px]",
                        sortable: ""
                      }, {
                        body: _withCtx((slotProps) => [
                          _createTextVNode(_toDisplayString($setup.formatDateTime(slotProps.data.createTime)), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "updateTime",
                        header: "Thời gian trả lời",
                        class: "h-[60px]",
                        sortable: ""
                      }, {
                        body: _withCtx((slotProps) => [
                          _createTextVNode(_toDisplayString($setup.formatDateTime(slotProps.data.updateTime)), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value", "filters"])
                ])
              ]),
              _: 1
            }, 8, ["visible"])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}